var projectFilterInit;

(function ($) {

	const selectors = {
		wrap: '[data-projects]',
		item: '[data-projects-project]',
		filtersWrap: '[data-projects-filters]',
		filter: '[data-projects-filter]',
		trigger: '[data-projects-filters-trigger]',
		content: '[data-projects-filters-content]',
		topFilter: '[data-projects-filter]', // Selector for top-level filters
		topMenuSubcategories: '.c-projects__filtry-top-menu .c-projects__subcategories' // Subcategories container
	}

	projectFilterInit = function () {
		$(selectors.wrap).each((i, el) => { new ProjectFilter(el); });
	}

	class ProjectFilter {

		constructor(el) {

			this.$wrap = $(el);

			if (this.$wrap.length) {
				this.init();
				this.bind();
			}
		}

		bind() {

			const self = this;

			this.$filter.on('click', this.onFilterClicked.bind(this));
			$(selectors.topMenuSubcategories).on('click', selectors.filter, this.onSubFilterClicked.bind(this)); // Bind click for subcategories

			$(window).on('load', () => { self.$wrap.isotope('layout') });

			// Bind click event for each filtersWrap to toggle visibility
			this.$trigger.each((i, wrap) => {
				const $wrap = $(wrap);
				$wrap.on('click', (e) => {
					e.stopPropagation();  // Prevents the click event from bubbling up

					if ($wrap.closest(this.$filtersWrap).hasClass('filters-visible')) {
						this.hideFilters($wrap.closest(this.$filtersWrap));
					} else {
						this.hideAllFilters();  // Hide all other dropdowns
						this.showFilters($wrap.closest(this.$filtersWrap));
					}
				});
			});


		}

		init() {

			this.$filtersWrap = $(selectors.filtersWrap);
			this.$filter = $(selectors.filter);
			this.$trigger = $(selectors.trigger, this.$filtersWrap);
			this.$content = $(selectors.content, this.$filtersWrap);
			this.$topFilter = $(selectors.topFilter);

			this.$wrap.isotope({
				// options
				itemSelector: selectors.item,
				// layoutMode: 'fitRows'
			});

		}

		onFilterClicked(e) {

			e.preventDefault();

			const $filter = $(e.target);
			// Check if the clicked element has the class 'c-projects__link'
			if ($filter.hasClass('c-projects__subcategory')) {
				return; // Exit the function if it does
			}
			if (!$filter.length) return;

			this.$filter.removeClass('is-active');
			$filter.addClass('is-active');

			const filter = $filter.attr('data-projects-filter');
			const filterType = $filter.attr('data-filter-type');  // New attribute to determine filter type (category or featured)

			// Show the corresponding subcategories
			this.showSubcategories(filter);

			let filterSelector = '';

			if (filter == '*') {
				filterSelector = '*';
				this.$filtersWrap.removeClass('is-active');
			} else {
				this.$filtersWrap.addClass('is-active');

				// Check the filter type and build the selector accordingly
				if (filterType === 'markets') {
					filterSelector = '[data-markets*="' + filter + '"]';
				} else if (filterType === 'featured') {
					filterSelector = '[data-featured*="' + filter + '"]';
				}
				else if (filterType === 'services') {
					filterSelector = '[data-services*="' + filter + '"]';
				}
			}

			this.$wrap.isotope({ filter: filterSelector });

			//this.hideFilters();
		}

		onSubFilterClicked(e) {
			e.preventDefault();

			const $filter = $(e.target);
			if (!$filter.length) return;


			this.$filter.removeClass('is-active');
			$filter.addClass('is-active');


			const filter = $filter.attr('data-projects-filter');
			const filterType = $filter.attr('data-filter-type');

			let filterSelector = '';

			if (filter == '*') {
				filterSelector = '*';
			} else {
				// Check the filter type and build the selector accordingly
				if (filterType === 'markets') {
					filterSelector = '[data-markets*="' + filter + '"]';
				} else if (filterType === 'featured') {
					filterSelector = '[data-featured*="' + filter + '"]';
				}
				else if (filterType === 'services') {
					filterSelector = '[data-services*="' + filter + '"]';
				}
			}


			this.$wrap.isotope({ filter: filterSelector });

			// Keep the top-level filter active and highlight the subcategory
			const topFilter = $filter.closest(selectors.topMenuSubcategories).attr('data-projects-top-filter');
			console.log($(`[data-projects-filter="${topFilter}"]`));
			$(`[data-projects-filter="${topFilter}"]`).addClass('is-active');
		}

		showSubcategories(filter) {

			const $subcategories = $(selectors.topMenuSubcategories);

			// Hide all subcategories
			$subcategories.hide();

			// Show the subcategories matching the clicked filter
			$subcategories.filter(`[data-projects-top-filter="${filter}"]`).slideDown();
		}

		showFilters($wrap) {
			$wrap.addClass('filters-visible');
			$wrap.find(selectors.content).stop().fadeIn();
		}

		hideFilters($wrap) {
			$wrap.removeClass('filters-visible');
			$wrap.find(selectors.content).stop().fadeOut();
		}

		hideAllFilters() {
			this.$filtersWrap.removeClass('filters-visible');
			this.$content.stop().fadeOut();
		}


	}


})(jQuery);


export default projectFilterInit;